import { render, staticRenderFns } from "./SmoothReflow.vue?vue&type=template&id=36563258"
import script from "./SmoothReflow.vue?vue&type=script&lang=js"
export * from "./SmoothReflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36563258')) {
      api.createRecord('36563258', component.options)
    } else {
      api.reload('36563258', component.options)
    }
    module.hot.accept("./SmoothReflow.vue?vue&type=template&id=36563258", function () {
      api.rerender('36563258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/transitions/SmoothReflow.vue"
export default component.exports